import React from "react";
import Frustracao from "../assets/Frustracao.jpeg";

const FrustracaoPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Contêiner principal */}
      <div className="flex flex-col md:flex-row items-center max-w-4xl w-full">
        {/* Imagem (sempre centralizada) */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={Frustracao}
            alt="Frustracao"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Texto (sempre centralizado) */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-8 text-center">
          <h1 className="text-3xl font-bold text-[#ad6a51] mb-4">Frustração</h1>
          <p className="text-lg text-[#4a4a4a] leading-relaxed">
            <br />
            Aprender a tolerar aqueles dias que não são marcados por conquistas
            e lidar com a frustração de não estar na perfeição.
            <br />
            <br />
            Poder acolher seu sentimento quando algo não sai como esperado, e
            dar espaço para elaborar a situação.
            <br />
            <br />
            Entender seu tempo de poder seguir em frente. Dar espaço para o que
            é novo pode ser surpreendente!
          </p>
        </div>
      </div>
    </div>
  );
};

export default FrustracaoPage;
